import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
    Container,
    Row,
    Col,
    // Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
import WorkType1 from "../common-for-all/WorkTypeOne"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { Editor } from "primereact/editor";
import Select from 'react-select';
import { Toast } from 'primereact/toast';
import { Link, useNavigate } from "react-router-dom";
import { FileUpload } from 'primereact/fileupload';
import WorkType from "../common-for-all/WorkType";
import AddProjectDetails from "pms/common-for-all/AddProjectDetails"
import { getCookie } from "../../helpers/cookie"
import axios from "axios"
import { InputTextarea } from "primereact/inputtextarea"
import { Button } from 'primereact/button';
import { get, set } from "lodash"
import { t } from "i18next"
import { NOTIFICATION_API_STATUS_FALSE, NOTIFICATION_API_STATUS_TRUE, SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"
import { useDispatch } from "react-redux"
const WorkTypeEditForm = props => {
      const dispatch = useDispatch()
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [createdBy, setcreatedBy] = useState("")
    const [createDate, setcreateDate] = useState("")
    const [editDate, seteditDate] = useState("")
    const [EditedBy, setEditedBy] = useState("")
    const params = new URLSearchParams(window.location.search);
    const EditId = params.get("id");
    const navigate = useNavigate()
    const fileUploadRef = useRef(null)
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [commentFiles, setCommentFiles] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    // Document states - consolidated and cleaned up
    const [selectedAssignee, setSelectedAssignee] = useState(null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [subject, setSubject] = useState('');
    const [file, setFile] = useState(null);
    const [selectedStatus1, setSelectedStatus1] = useState(null);
    const [workhours, setworkhours] = useState("")
    const [Summary, setSummary] = useState('')
    const [selectedPriority, setSelectedPriority] = useState(null)
    const [priorityOptions, setpriorityOptions] = useState([])
    const [lastSelectedPriorityId, setLastSelectedPriorityId] = useState(null);
    const [worktypestatus, setWorkTypeStatus] = useState([])
    const [selectedWorkTypeStatus, setselectedWorkTypeStatus] = useState(null)
    const [lastSelectedWorkTypeStatusId, setLastSelectedWorkTypeStatusId] = useState(null);
    const [lastSelectedDocumentTypeId, setLastSelectedDocumentTypeId] = useState(null);
    const [lastSelectedWorkTypeEntityId, setLastSelectedWorkTypeEntityId] = useState(null);
    const [lastSelectedApprovalId, setLastSelectedApprovalId] = useState(null);
    const [WorkType, setWorkType] = useState([])
    const [selectedWorkType, setselectedWorkType] = useState([])
    const selectedValue = WorkType.find((item) => item.id === selectedWorkType)?.value;
    const [commentDialogVisible, setCommentDialogVisible] = useState(false);

    const [privateDrop, setPrivateDrop] = useState([]);
    const [popchecked2, setPopchecked2] = useState(false);
    const [PrivetDropdownValues, setPrivetDropdownValues] = useState([])
    const [selectedWatchers, setSelectedWatchers] = useState(null)
    const [approvalStatus, setApprovalStatus] = useState(null)
    const [statusOptions, setstatusOptions] = useState([])
    const [selectedStatus, setSelectedStatus] = useState([])
    const [Watchers, setWatchers] = useState([])
    const [loader, setLoader] = useState(true)
    // Private functionality
    const getwatchers = async (projectId) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/employees/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setWatchers(response.data?.results);
                setLoader(false);
            }
        } catch (err) {
            console.error("Failed to load modules:", err);
        }
    };
    const getWorkType = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setWorkType(response.data?.results?.results);
            }
        } catch (err) {
            console.error("Failed to load modules:", err);
        }
    };
    const getPriorityOptions = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=priority`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                const results = response.data?.results?.results || response.data?.results || [];
                const mapped = results.map((item) => ({
                    name: item.value,
                    id: item.id
                }));

                setpriorityOptions(mapped);
            }
        } catch (err) {
            console.error("Failed to load modules:", err);
        }
    };
    const getApprovalStatus = async (id) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/approval-status/?project_id=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.status === 200) {
                let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;

                setstatusOptions(tasksStatus);
            }
        } catch (err) {
            console.error("Failed to load modules:", err);
        }
    };
    const getPrivateOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data) {
                let results = response.data.data;
                console.log(results, 'results');
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    value: category.id,
                    email: category.email
                }));
                setPrivetDropdownValues(options);
            }
        } catch (error) {

        }
    };


    // const PrivetDropdownValues = [
    //     { name: "Harish", value: "Harish" },
    //     { name: "Mahesh", value: "Mahesh" },
    //     { name: "Lavan", value: "Lavan" },
    //     { name: "Vinay", value: "Vinay" },
    //     { name: "Vasanth", value: "Vasanth" }
    // ];

    const handlePopupCheckbox2 = e => {
        setPopchecked2(e.checked);
        if (!e.checked) {
            setPrivateDrop([]);
        }
    };
    const getWorkTypeStatus = async (id) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/task-status/?project_id=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                 let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
                    setWorkTypeStatus(tasksStatus);
            }
        } catch (err) {
            console.error("Failed to load work type status:", err);
        }
    };

    const handleUpload = (e) => {
        setFile(e.files[0]);
    };

    const customBase64Uploader2 = (event) => {
        setFile(event.files[0]);
    };
    const [docloader, setDocloader] = useState(false);
    const handleAddDocument = async () => {
        // if (!selectedDocument || !subject) {
        //     alert('Please fill all the fields.');
        //     return;
        // }
        if (!uploadedFiles || uploadedFiles.length === 0) {
            alert('Please attach a document.');
            return;
        }
        try {
            setDocloader(true);
            const formData = new FormData();
            const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
            const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;

            // formData.append('type', selectedDocument);
            formData.append('task', EditId);

            // Append uploaded files
            if (uploadedFiles && uploadedFiles.length > 0) {
                uploadedFiles.forEach((file) => {
                    formData.append('file', file);
                });
            }

            // Send request
            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/employee-task-documents/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            if (response.status === 201 || response.status === 200) {
                // Reload documents and reset state
                getDocuments();
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setFile(null);
                setDocloader(false);
                setUploadedFiles([]);
                toast.current?.show({ severity: 'success', summary: 'Saved', detail: 'Document added' });
            }

        } catch (err) {
            console.error('Failed to upload document', err);
            setDocloader(false);
        }
    };
    const [commentloader, setCommentloader] = useState(false);
const handleAddComment = async () => {
        try {
            setCommentloader(true);
            if (!comment?.trim()) {
                toast.current?.show({ severity: 'warn', summary: 'Validation Error', detail: 'Comment text cannot be empty' });
                return;
            }
            const formData = new FormData();

            formData.append('comment_text', comment);
            formData.append('task', EditId);
            // formData.append('description', subject);

            // Append uploaded files
            if (commentFiles && commentFiles.length > 0) {
                commentFiles.forEach((file) => {
                    formData.append('files', file);
                });
            }

            // Send request
            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/task/comments/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            if (response.status === 201 || response.status === 200) {
                setDisplayDialog(false);
                setCommentFiles(null);
                setComment('');
                setFile(null);
                getComments();
                setCommentFiles([]);
                closeAddDocumentDialog();
                setCommentloader(false);
                toast.current?.show({ severity: 'success', summary: 'Saved', detail: 'Comment added' });
            }

        } catch (err) {
            console.error('Failed to add comment', err);
            // alert('Failed to upload document');
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to add comment' });
            setCommentloader(false);
        }
    };
    const openAddDocumentDialog = () => {
        setDisplayDialog(true);
    };

    const closeAddDocumentDialog = () => {
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setFile(null);
        setUploadedFiles([]);
        setComment('');
        setCommentFiles([]);
        setCommentDialogVisible(false);
    };
    const token = getCookie('access_token');
    const [selectedProject, setselectedProject] = useState([])
    const [projectNameWorkTypes, setProjectNameWorkTypes] = useState([]);
    const [selectedModule, setselectedModule] = useState([])
    const [moduleWorkTypes, setModuleWorkTypes] = useState([]);
    const [SelectedEditdrop, setSelectedEditdrop] = useState(null);
    const [lastSelectedModuleId, setLastSelectedModuleId] = useState(null);
    const [lookupModalVisible, setLookupModalVisible] = useState(false)
    const [lookupModalContext, setLookupModalContext] = useState('')
    const [lookupFormValue, setLookupFormValue] = useState('')
    const [editingLookup, setEditingLookup] = useState(false)
    const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null)
    const [description, setdescription] = useState('')

    useEffect(() => {
        if (selectedModule && selectedModule !== 'add' && selectedModule !== 'edit') {
            setLastSelectedModuleId(selectedModule);
        }

        if (selectedModule === 'add') {
            setLookupModalVisible(true);
            setLookupFormValue('');
            setEditingLookup(false);
            setLookupModalContext('work_type_module');
            setselectedModule(null);
        } else if (selectedModule === 'edit') {
            if (lastSelectedModuleId) {
                setEditingLookup(true);
                setSelectedEditdrop(lastSelectedModuleId);
                const current = moduleWorkTypes?.find(opt => opt.id === lastSelectedModuleId);
                setLookupFormValue(current?.value || current?.name || '');
                setLookupModalVisible(true);
                setLookupModalContext('work_type_module');
                setselectedModule(lastSelectedModuleId);
                setLastSelectedLookupId(lastSelectedModuleId);
            } else {
                console.warn('No module selected to edit!');
            }
        }
    }, [selectedModule, lastSelectedModuleId]);
    const getModule = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/modules/?project_id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                  let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
                setModuleWorkTypes(tasksStatus)
            }
        } catch (err) {
            console.log(err);

        }
    }
    const getDocuments = async () => {
        try {
            // If EditId present, fetch documents related to this work type
            // const url = EditId ? `${process.env.REACT_APP_Company_Contact}/company/worktypes/${EditId}/documents/` : `${process.env.REACT_APP_Company_Contact}/company/documents/`;
            const url = EditId ? `${process.env.REACT_APP_Company_Contact}/company/employee-task-documents/by-task/${EditId}/` : `${process.env.REACT_APP_Company_Contact}/company/employee-task-documents/`;

            const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
            if (response.status === 200) {
                const results = response.data?.results || [];
                setDocuments(results || []);
            }
        } catch (err) {
            console.error('Failed to load documents', err);
        }
    }
    const [ProjectCount, setProjectCount] = useState(10)
    const getProject = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/projects/?limit=${ProjectCount}&offset=0`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setProjectNameWorkTypes(response.data.results)
                setProjectCount(response.data.count)
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        getProject()
    }, [ProjectCount])
    const [comments, setComments] = useState()
    const [comment, setComment] = useState('')
    const getComments = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/comments/list/?task_id=${EditId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                
                setComments(response.data)
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        getComments()
    }, [EditId])
    const getSingleWorkType = async (id) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/worktypes/${id}/`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
                const data = response.data;
                setselectedProject(data.project)
                getModule(data.project)
                getWorkTypeStatus(data.project)
                getApprovalStatus(data.project)
                setworkhours(data.work_hours)
                setJobStartDate(data.start_date ? new Date(data.start_date) : null);
                setJobendDate(data.end_date ? new Date(data.end_date) : null);
                setJobActualDate(data.actual_end_date ? new Date(data.actual_end_date) : null);
                setcreateDate(data.setEditedBy ? new Date(data.setEditedBy) : null);
                seteditDate(data.updated_at ? new Date(data.updated_at) : null);
                setcreatedBy(data?.created_by_name);
                setEditedBy(data?.updated_by_name);
                setSummary(data.summary)
                setSelectedPriority(data.priority);
                setselectedWorkType(data.work_type || null);
                setSelectedStatus(data.approval_status);
                setSelectedManager(data.project_manager_name || null);
                setSelectedAssignee(data.assigned_to_employee?.full_name || null);
                setContent(data.summary || '');
                // setSelectedWatchers(data.watchers || []);
                const watcherIds = data.watchers.map(w => w.id);
                setSelectedWatchers(watcherIds);
                setselectedWorkTypeStatus(data?.work_type_status)
                setPrivateDrop(data.private_user_ids || []);
                setPopchecked2(data.is_private || false);
                setselectedModule(data.module || null);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        if (EditId) {
            getSingleWorkType(EditId)
            getProject()
            // getModule(selectedProject)
            getPriorityOptions()
            getWorkType()
            // getApprovalStatus(selectedProject)
            // getWorkTypeStatus(selectedProject)
            getDocuments()
            getDocumentTypes()
            getPrivateOptions()
            getwatchers()
        }
    }, [])

    useEffect(() => {
        console.debug('selectedPriority effect fired:', selectedPriority)
        if (!selectedPriority) return
        if (selectedPriority === 'add') {
            setLookupModalContext('priority')
            setLookupFormValue('')
            setEditingLookup(false)
            setLookupModalVisible(true)
            setSelectedPriority(null)
            setLastSelectedLookupId(null)
            return
        }

        if (selectedPriority === 'edit') {
            if (lastSelectedPriorityId) {
                setEditingLookup(true)
                const current = priorityOptions.find(p => p.id === lastSelectedPriorityId)
                setLookupFormValue(current ? (current.name || current.value || '') : '')
                setLookupModalContext('priority')
                setLookupModalVisible(true)
                setSelectedPriority(lastSelectedPriorityId);
                setLastSelectedLookupId(lastSelectedPriorityId)
            } else {
                console.warn('No priority selected to edit!')
            }
            return
        }

        // normal selection -> store id for potential edit
        setLastSelectedPriorityId(selectedPriority)
        setLastSelectedLookupId(selectedPriority)
    }, [selectedPriority, lastSelectedPriorityId, priorityOptions])

    useEffect(() => {
        console.debug('selectedWorkType effect fired:', selectedWorkType)
        if (!selectedWorkType) return
        if (selectedWorkType === 'add') {
            setLookupModalContext('work_type')
            setLookupFormValue('')
            setEditingLookup(false)
            setLookupModalVisible(true)
            setselectedWorkType(null)
            setLastSelectedLookupId(null)
            return
        }

        if (selectedWorkType === 'edit') {
            if (lastSelectedWorkTypeEntityId) {
                setEditingLookup(true)
                const current = WorkType.find(w => w.id === lastSelectedWorkTypeEntityId)
                setLookupFormValue(current ? (current.value || current.name || '') : '')
                setLookupModalContext('work_type')
                setLookupModalVisible(true)
                setselectedWorkType(lastSelectedWorkTypeEntityId);
                setLastSelectedLookupId(lastSelectedWorkTypeEntityId)
                setSelectedEditdrop(lastSelectedWorkTypeEntityId);
            } else {
                console.warn('No work type selected to edit!')
            }
            return
        }

        setLastSelectedWorkTypeEntityId(selectedWorkType)
        setLastSelectedLookupId(selectedWorkType)
    }, [selectedWorkType, lastSelectedWorkTypeEntityId, WorkType])

    useEffect(() => {
        console.debug('selectedStatus effect fired:', selectedStatus)
        if (!selectedStatus) return
        if (selectedStatus === 'add') {
            setLookupModalContext('approval')
            setLookupFormValue('')
            setEditingLookup(false)
            setLookupModalVisible(true)
            setSelectedStatus(null)
            setLastSelectedLookupId(null)
            return
        }

        if (selectedStatus === 'edit') {
            if (lastSelectedApprovalId) {
                setEditingLookup(true)
                const current = statusOptions.find(s => s.id === lastSelectedApprovalId)
                setLookupFormValue(current ? (current.value || current.name || '') : '')
                setLookupModalContext('approval')
                setLookupModalVisible(true)
                setSelectedStatus(lastSelectedApprovalId);
                setLastSelectedLookupId(lastSelectedApprovalId)
            } else {
                console.warn('No approval status selected to edit!')
            }
            return
        }

        setLastSelectedApprovalId(selectedStatus)
        setLastSelectedLookupId(selectedStatus)
    }, [selectedStatus, lastSelectedApprovalId, statusOptions])

    useEffect(() => {
        console.debug('selectedWorkTypeStatus effect fired:', selectedWorkTypeStatus)
        if (!selectedWorkTypeStatus) return
        if (selectedWorkTypeStatus === 'add') {
            setLookupModalContext('work_type_status')
            setLookupFormValue('')
            setEditingLookup(false)
            setLookupModalVisible(true)
            setselectedWorkTypeStatus(null)
            setLastSelectedLookupId(null)
            return
        }

        if (selectedWorkTypeStatus === 'edit') {
            console.log(selectedWorkTypeStatus);

            if (lastSelectedWorkTypeStatusId) {
                setEditingLookup(true)
                const current = worktypestatus.find(w => w.id === lastSelectedWorkTypeStatusId)
                setLookupFormValue(current ? (current.name || current.value || '') : '')
                setLookupModalContext('work_type_status')
                setLookupModalVisible(true)
                setselectedWorkTypeStatus(lastSelectedWorkTypeStatusId);
                setLastSelectedLookupId(selectedWorkTypeStatus);
                setSelectedEditdrop(selectedWorkTypeStatus);
            } else {
                console.warn('No work type status selected to edit!')
            }
            return
        }

        setLastSelectedWorkTypeStatusId(selectedWorkTypeStatus)
        setLastSelectedLookupId(selectedWorkTypeStatus)
    }, [selectedWorkTypeStatus, lastSelectedWorkTypeStatusId, worktypestatus])

    // Watch document type dropdown selection to support Add / Edit sentinel options
    useEffect(() => {
        console.debug('selectedDocument effect fired:', selectedDocument)
        if (!selectedDocument) return

        if (selectedDocument === 'add') {
            setLookupModalContext('work_type_document')
            setLookupFormValue('')
            setEditingLookup(false)
            setLookupModalVisible(true)
            setSelectedDocument(null)
            setLastSelectedLookupId(null)
            return
        }

        if (selectedDocument === 'edit') {
            if (lastSelectedDocumentTypeId) {
                setEditingLookup(true)
                const current = documentTypes.find(d => d.id === lastSelectedDocumentTypeId)
                setLookupFormValue(current ? (current.name || current.value || '') : '')
                setLookupModalContext('work_type_document')
                setLookupModalVisible(true)
                setSelectedDocument(lastSelectedDocumentTypeId);
                setLastSelectedLookupId(lastSelectedDocumentTypeId)
            } else {
                console.warn('No document type selected to edit!')
            }
            return
        }

        // store the last selected id for edit operations
        setLastSelectedDocumentTypeId(selectedDocument)
        setLastSelectedLookupId(selectedDocument)
    }, [selectedDocument, lastSelectedDocumentTypeId, documentTypes])
    const getDocumentTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type_document`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const results = response.data?.results?.results || response.data?.results || [];
                const mapped = results.map((item) => ({
                    id: item.id,
                    name: (item.value || '').replace(/_/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase())
                }));
                setDocumentTypes(mapped);
            }
        } catch (err) {
            console.error('Failed to load document types', err);
        }
    }
    const groupedDocuments = [
        {
            label: 'Project Documentation',
            items: [
                { label: 'Project Requirements Document', value: 'Project Requirements Document' },
                { label: 'Technical Specifications', value: 'Technical Specifications' },
                { label: 'Design Documents', value: 'Design Documents' },
                { label: 'User Stories', value: 'User Stories' },
                { label: 'Test Plans', value: 'Test Plans' }
            ]
        },
        {
            label: 'Legal and Compliance',
            items: [
                { label: 'Project Charter', value: 'Project Charter' },
                { label: 'Stakeholder Agreement', value: 'Stakeholder Agreement' },
                { label: 'Risk Assessment', value: 'Risk Assessment' },
                { label: 'Compliance Documentation', value: 'Compliance Documentation' }
            ]
        },
        {
            label: 'Development Assets',
            items: [
                { label: 'Source Code Documentation', value: 'Source Code Documentation' },
                { label: 'API Documentation', value: 'API Documentation' },
                { label: 'Database Schema', value: 'Database Schema' },
                { label: 'Deployment Guide', value: 'Deployment Guide' }
            ]
        }
    ];

    const groupedItemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <i className="pi pi-file mr-2"></i>
                <div>{option.label}</div>
            </div>
        );
    };



    const [watcherWorkTypes, setWatcherWorkTypes] = useState([
        {
            name: 'Ravi Sharma',
            color: '#4c9aff',
            id: 'ravi-sharma',
            statuses: ['Available', 'Busy', 'Offline']
        },
        {
            name: 'Priya Sharma - Designer',
            color: '#36b37e',
            id: 'priya-sharma',
            statuses: ['Available', 'Busy', 'Offline']
        },
        {
            name: 'Amit Singh - Tester',
            color: '#ff5630',
            id: 'amit-singh',
            statuses: ['Available', 'Busy', 'Offline']
        }
    ]);

    const [taskWorkTypes, setTaskWorkTypes] = useState([
        {
            name: 'Task',
            color: '#4c9aff',
            id: 'task',
            statuses: ['To Do', 'In Progress', 'Done']
        },
        {
            name: 'Bug',
            color: '#ff5630',
            id: 'bug',
            statuses: ['Open', 'In Progress', 'Fixed', 'Closed']
        },
        {
            name: 'Story',
            color: '#36b37e',
            id: 'story',
            statuses: ['To Do', 'In Progress', 'Done']
        }
    ]);

    const [statusWorkTypes, setStatusWorkTypes] = useState([
        {
            name: 'To Do',
            color: '#6c757d',
            id: 'todo',
            statuses: ['Open', 'Assigned']
        },
        {
            name: 'In Progress',
            color: '#007bff',
            id: 'in-progress',
            statuses: ['Active', 'Working']
        },
        {
            name: 'In Review',
            color: '#28a745',
            id: 'in-review',
            statuses: ['Completed', 'Closed']
        },
        {
            name: 'Testing / QA',
            color: '#6c757d',
            id: 'testing-qa',
            statuses: ['Open', 'Assigned']
        },
        {
            name: 'Blocked',
            color: '#007bff',
            id: 'in-progress',
            statuses: ['Active', 'Working']
        },
        {
            name: 'Done',
            color: '#28a745',
            id: 'done',
            statuses: ['Completed', 'Closed']
        },
        {
            name: 'Cancelled',
            color: '#dc3545',
            id: 'cancelled',
            statuses: ['Cancelled']
        }
    ]);

    const [priorityWorkTypes, setPriorityWorkTypes] = useState([
        {
            name: 'High',
            color: '#dc3545',
            id: 'high',
            statuses: ['Critical', 'Urgent']
        },
        {
            name: 'Medium',
            color: '#ffc107',
            id: 'medium',
            statuses: ['Normal', 'Standard']
        },
        {
            name: 'Low',
            color: '#28a745',
            id: 'low',
            statuses: ['Minor', 'Optional']
        }
    ]);

    const [approvalStatusWorkTypes, setApprovalStatusWorkTypes] = useState([
        {
            name: 'Approved',
            color: '#28a745',
            id: 'active',
            statuses: ['Approved', 'Live']
        },
        {
            name: 'Rejected',
            color: '#6c757d',
            id: 'inactive',
            statuses: ['Disabled', 'Paused']
        },
        {
            name: 'Pending',
            color: '#ffc107',
            id: 'pending',
            statuses: ['Under Review', 'Waiting']
        }
    ]);

    // Callback handlers for work type changes
    const handleProjectNameWorkTypesChange = (updatedWorkTypes) => {
        setProjectNameWorkTypes(updatedWorkTypes);
    };

    const handleModuleWorkTypesChange = (updatedWorkTypes) => {
        setModuleWorkTypes(updatedWorkTypes);
    };

    const handleWatcherWorkTypesChange = (updatedWorkTypes) => {
        setWatcherWorkTypes(updatedWorkTypes);
    };

    const handleTaskWorkTypesChange = (updatedWorkTypes) => {
        setTaskWorkTypes(updatedWorkTypes);
    };

    const handleStatusWorkTypesChange = (updatedWorkTypes) => {
        setStatusWorkTypes(updatedWorkTypes);
    };

    const handlePriorityWorkTypesChange = (updatedWorkTypes) => {
        setPriorityWorkTypes(updatedWorkTypes);
    };

    const handleApprovalStatusWorkTypesChange = (updatedWorkTypes) => {
        setApprovalStatusWorkTypes(updatedWorkTypes);
    };

    // Selection change handlers
    const handleProjectNameSelectionChange = (selectedWorkType) => {
        console.log('Selected Project:', selectedWorkType);
    };

    const handleModuleSelectionChange = (selectedWorkType) => {
        console.log('Selected Module:', selectedWorkType);
    };

    const handleWatcherSelectionChange = (selectedWorkType) => {
        console.log('Selected Watcher:', selectedWorkType);
    };

    const handleTaskSelectionChange = (selectedWorkType) => {
        console.log('Selected Task Type:', selectedWorkType);
    };

    const handleStatusSelectionChange = (selectedWorkType) => {
        console.log('Selected Status:', selectedWorkType);
    };

    const handlePrioritySelectionChange = (selectedWorkType) => {
        console.log('Selected Priority:', selectedWorkType);
    };

    const handleApprovalStatusSelectionChange = (selectedWorkType) => {
        console.log('Selected Approval Status:', selectedWorkType);
    };

    const companies = [
        { label: 'Tech Solutions Inc.', value: 'Tech Solutions Inc.' },
        { label: 'Innovatech Ltd.', value: 'Innovatech Ltd.' },
        { label: 'Future Vision Corp.', value: 'Future Vision Corp.' },
        { label: 'Global Dynamics', value: 'Global Dynamics' }
    ];
    const [jobtitle, setJobtitle] = useState("Web Developer");
    const [workplaceType, setWorkplaceType] = useState(null);

    const workplaceOptions = [
        { name: 'Work from Office (WFO)', code: 'WFO' },
        { name: 'Work from Home (WFH)', code: 'WFH' },
        { name: 'Work from Remote (WFR)', code: 'WFR' }
    ];

    const [jobType, setJobType] = useState(null);

    const jobTypeOptions = [
        { name: 'Full Time', code: 'FT' },
        { name: 'Part Time', code: 'PT' },
        { name: 'Contract', code: 'CON' }
    ];

    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const departments = [
        { label: 'Account Finance Team', value: 'Account Finance Team' },
        { label: 'SPG US Staffing', value: 'SPG US Staffing' },
        { label: 'Vitel Development Team', value: 'Vitel Development Team' },
        { label: 'Support Team', value: 'Support Team' },
        { label: 'NOC Team', value: 'NOC Team' },
        { label: 'Digital Marketing Team', value: 'Digital Marketing Team' },
        { label: 'Executive Team', value: 'Executive Team' },
        { label: 'Operations Team', value: 'Operations Team' }
    ];


    const [selectedLocation, setSelectedLocation] = useState(null);

    const locations = [
        { label: 'Hyderabad', value: 'Hyderabad' },
        { label: 'Chennai', value: 'Chennai' },
        { label: 'Mumbai', value: 'Mumbai' },
        { label: 'Bangalore', value: 'Bangalore' },
        { label: 'Delhi', value: 'Delhi' }
    ];

    
    const managers = [
        { name: 'Ram Mohan', role: 'HR', code: 'HR' },
        { name: 'Sita Verma', role: 'Manager', code: 'MGR' },
        { name: 'Amit Sharma', role: 'Team Lead', code: 'TL' },
        { name: 'Ravi Kapoor', role: 'CEO', code: 'CEO' },
        { name: 'Neha Patel', role: 'Intern', code: 'INT' }
    ];
    const [openings, setOpenings] = useState("5");
    const [totalExperience, setTotalExperience] = useState("3");
    const [email, setEmail] = useState(null);
    const [address, setAddress] = useState();
    const [minSalary, setMinSalary] = useState("600000");
    const [maxSalary, setMaxSalary] = useState("800000");
    const [jobStartDate, setJobStartDate] = useState(null);
    const [jobendDate, setJobendDate] = useState(null);
    const [jobActualDate, setJobActualDate] = useState(null);
    const [selectedMod, setSelectedMod] = useState(null)
    const [nodes, setNodes] = useState(null);
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [skillsOptions, setSkillsOptions] = useState([
        { value: "java", label: "Java" },
        { value: "react", label: "React" },
        { value: "nodejs", label: "Node.js" },
    ]);
    const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([]);
    const [selectedSecondarySkills, setSelectedSecondarySkills] = useState([]);
    const [selectedJobFunction, setSelectedJobFunction] = useState(null);
    const [selectedSeniority, setSelectedSeniority] = useState(null);
    const [queVisible, setQueVisible] = useState(false);
    const [isQualificationRequired, setIsQualificationRequired] = useState(false);
    const [isQualificationRequired1, setIsQualificationRequired1] = useState(false);
    const [questionsData, setQuestionsData] = useState([]);
    const [question, setQuestion] = useState("CSS");
    const [answer, setAnswer] = useState("3");
    const [question1, setQuestion1] = useState("Html");
    const [answer1, setAnswer1] = useState("3");
    const [questions, setQuestions] = useState([]);
    const [category, setCategory] = useState("Frontend");
    const [group, setGroup] = useState("Html, CSS");

    // Define dropdownWorkTypes for Project Name, Module, Status, Priority, Watcher, etc.
    const projectNameDropdownWorkTypes = [
        ...projectNameWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Project', id: 'add' },
        { name: 'Edit Project', id: 'edit' }
    ];

    const moduleDropdownWorkTypes = [
        ...moduleWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Module', id: 'add' },
        { name: 'Edit Module', id: 'edit' }
    ];

    const watcherDropdownWorkTypes = [
        ...watcherWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Watcher', id: 'add' },
        { name: 'Edit Watcher', id: 'edit' }
    ];

    const taskDropdownWorkTypes = [
        ...taskWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Task Type', id: 'add' },
        { name: 'Edit Task Type', id: 'edit' }
    ];

    const statusDropdownWorkTypes = [
        ...statusWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Status', id: 'add' },
        { name: 'Edit Status', id: 'edit' }
    ];

    const priorityDropdownWorkTypes = [
        ...priorityWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Priority', id: 'add' },
        { name: 'Edit Priority', id: 'edit' }
    ];

    const approvalStatusDropdownWorkTypes = [
        ...approvalStatusWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Status', id: 'add' },
        { name: 'Edit Status', id: 'edit' }
    ];

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    const [content, setContent] = useState();

    const maxWords = 500;

    const calculateWordCount = (text) => {
        const words = text?.trim()
            .replace(/<[^>]*>/g, "")
            .split(/\s+/);
        return words?.filter((word) => word).length;
    };

    const currentWordCount = calculateWordCount(content);

    const handleEditorChange = (e) => {
        const text = e.htmlValue || "";
        if (calculateWordCount(text) <= maxWords) {
            setContent(text);
        }
    };

    const toast = useRef(null);

    const showMessage = () => {
        toast.current?.show({ severity: 'info', summary: 'Job ID 3048 Saved' });
    };

    const showCancel = () => {
        toast.current?.show({ severity: 'error', summary: 'Cancelled', life: 3000 });
    }
    const handlePrioritySave = async () => {
        try {
            const token = getCookie('access_token')
            const body = {
                name: 'priority',
                value: lookupFormValue,
                description: lookupFormValue,
                type: 'company'
            }
            if (editingLookup) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedPriorityId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
            }
            // close modal and reset state to avoid re-triggering the add/edit useEffect
            setLookupModalVisible(false)
            // setEditingLookup(false)
            setLookupFormValue('')
            try { setSelectedPriority(null) } catch (e) { }
            getPriorityOptions()
        } catch (err) {
            console.error(err)
        }
    }

    const handleWorkTypeSave = async () => {
        try {
            const token = getCookie('access_token')
            const body = {
                name: 'work_type',
                value: lookupFormValue,
                description: lookupFormValue,
                type: 'company'
            }
            if (editingLookup) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedWorkTypeEntityId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
            }
            // close modal and reset state to avoid re-triggering the add/edit useEffect
            setLookupModalVisible(false)
            // setEditingLookup(false)
            setLookupFormValue('')
            try { setselectedWorkType(null) } catch (e) { }
            getWorkType()
        } catch (err) {
            console.error(err)
        }
    }

    const handleApprovalSave = async () => {
        try {
            const token = getCookie('access_token')
            const body = {
                name: 'approval_status',
                value: lookupFormValue,
                description: lookupFormValue,
                type: 'company'
            }
            if (editingLookup && lastSelectedApprovalId) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedApprovalId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
            }
            // close modal and reset state to avoid re-triggering the add/edit useEffect
            setLookupModalVisible(false)
            // setEditingLookup(false)
            setLookupFormValue('')
            try { setSelectedStatus(null) } catch (e) { }
            // getApprovalStatus()
        } catch (err) {
            console.error(err)
        }
    }

    const handleWorkTypeStatusSave = async () => {
        try {
            const token = getCookie('access_token')
            const body = {
                name: 'work_type_status',
                value: lookupFormValue,
                description: lookupFormValue,
                type: 'company'
            }
            if (editingLookup && lastSelectedWorkTypeStatusId) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedWorkTypeStatusId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
            }
            setLookupModalVisible(false)
            // setEditingLookup(false)
            setLookupFormValue('')
            try { setselectedWorkTypeStatus(null) } catch (e) { }
            getWorkTypeStatus(selectedProject)
        } catch (err) {
            console.error(err)
        }
    }

    const handleDocumentTypeSave = async () => {
        try {
            const token = getCookie('access_token')
            const body = {
                name: 'work_type_document',
                value: lookupFormValue,
                description: description || lookupFormValue,
                type: 'Work Type Document'
            }
            if (editingLookup && lastSelectedDocumentTypeId) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedDocumentTypeId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
            }
            setLookupModalVisible(false)
            // setEditingLookup(false)
            setLookupFormValue('')
            try { setSelectedDocument(null) } catch (e) { }
            getDocumentTypes()
        } catch (err) {
            console.error(err)
        }
    }

    const handleModalSave = async () => {
        try {
            await handleLookupSave()
        } catch (err) {
            console.error('Error saving modal:', err)
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        const formatDate = (d) => {
            if (!d) return null;
            if (typeof d === 'string') return d;
            try {
                return new Date(d).toISOString().split('T')[0];
            } catch (err) {
                return null;
            }
        };

        try {
            // const formData = {
            //     project: selectedProject && (selectedProject.id || selectedProject),
            //     module: selectedModule && (selectedModule.id || selectedModule),
            //     work_type: selectedWorkType || null,
            //     summary: Summary || '',
            //     priority: selectedPriority || null,
            //     work_hours: workhours || null,
            //     start_date: formatDate(jobStartDate),
            //     end_date: formatDate(jobendDate),
            //     actual_end_date: formatDate(jobActualDate),
            //     approval_status: selectedStatus,
            //     task_status: selectedStatus || null,
            //     watcher_ids: selectedWatchers || [],
            //     // is_private: popchecked2 || false,
            //     // private_users: privateDrop || [],
            //     work_type_status : selectedWorkTypeStatus || null,
            // };
            const payload = new FormData();

            // simple fields
            payload.append("project", selectedProject?.id || selectedProject || "");
            payload.append("module", selectedModule?.id || selectedModule || "");
            payload.append("work_type", selectedWorkType || "");
            payload.append("summary", Summary || "");
            payload.append("priority", selectedPriority || "");
            payload.append("work_hours", workhours || "");
            payload.append("start_date", formatDate(jobStartDate));
            payload.append("end_date", formatDate(jobendDate));
            payload.append("actual_end_date", formatDate(jobActualDate));
            payload.append("approval_status", selectedStatus || "");
            payload.append("task_status", selectedStatus || "");
            payload.append("work_type_status", selectedWorkTypeStatus || "");
            payload.append("watcher_ids", selectedWatchers)

            const response = await axios.patch(
                `${process.env.REACT_APP_Company_Contact}/company/worktypes/${EditId}/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setLoader(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Work type updated successfully',
                    life: 3000
                });
                navigate('/allactive-worktype')
            }
            dispatch({ type: SET_API_STATUS_TRUE })
            dispatch({ type: NOTIFICATION_API_STATUS_TRUE })
            setTimeout(() => {
                dispatch({ type: SET_API_STATUS_FALSE })
                dispatch({ type: NOTIFICATION_API_STATUS_FALSE })
            }, 2000)
        } catch (error) {
            console.error('Error updating worktype:', error);
            setLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Failed to update work type',
                life: 3000
            });
        }
    }
    const [selecteddropoptions, setselecteddropoptions] = useState([])
    useEffect(() => {
        // Map lookupModalContext to the proper source list and normalize each item
        const mapList = (list) => (list || []).map(d => ({ id: d.id ?? d.code ?? d.value ?? d.name ?? String(d), name: d.value || d.name || d.label || String(d.id || d), code: d.code, raw: d }));

        switch (lookupModalContext) {
            case 'work_type_module':
                setselecteddropoptions(mapList(moduleWorkTypes));
                break;
            case 'project_status':
                setselecteddropoptions(mapList(statusWorkTypes));
                break;
            case 'priority':
                setselecteddropoptions(mapList(priorityOptions));
                break;
            case 'approval_status':
                setselecteddropoptions(mapList(statusOptions));
                break;
            case 'work_type_status':
                setselecteddropoptions(mapList(worktypestatus));
                break;
            case 'work_type':
                setselecteddropoptions(mapList(WorkType));
                break;
            case 'work_type_document':
                setselecteddropoptions(mapList(documentTypes));
                break;
            default:
                console.log('No valid lookup context, clearing options');

                setselecteddropoptions([]);
        }
    }, [lookupModalContext, moduleWorkTypes, statusWorkTypes, priorityOptions, priorityWorkTypes, statusOptions, approvalStatusWorkTypes, worktypestatus, WorkType, documentTypes])
    const handleLookupSave = async () => {
        try {
            if (lookupFormValue?.trim() === '') {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
                return
            }
            const token = getCookie('access_token')
            const payload = { name: lookupModalContext, value: lookupFormValue, description: description, type: '' }
            if (editingLookup && lastSelectedLookupId) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, payload, { headers: { Authorization: `Bearer ${token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, payload, { headers: { Authorization: `Bearer ${token}` } })
            }

            // Refresh relevant lists depending on context
            switch (lookupModalContext) {
                case 'work_type_module':
                    await getModule();
                    break;
                case 'project_status':
                    if (typeof getProjectStatus === 'function') await getProjectStatus();
                    break;
                case 'priority':
                    await getPriorityOptions();
                    break;
                case 'approval_status':
                    await getApprovalStatus();
                    break;
                case 'work_type_status':
                    await getWorkTypeStatus();
                    break;
                case 'work_type_document':
                    await getDocumentTypes();
                    break;
                case 'work_type':
                    await getWorkType();
                    break;
                default:
                    break;
            }

            setLookupModalVisible(false)
            setdescription('')
            setLookupFormValue('')
            setEditingLookup(false)
            setLastSelectedLookupId(null)
            setSuccessAlert(true)
        } catch (err) {
            console.error('Error saving lookup', err.response?.data?.errors?.non_field_errors)
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.errors?.non_field_errors && err.response?.data?.errors?.non_field_errors[0] === 'The fields tenant, company, name, value must make a unique set.' ? 'The Value Already Exists' : 'Failed to save lookup' })
        }
    }
    const PRIORITY_CHOICES = [
        { value: 'HIGH', name: 'High' },
        { value: 'MEDIUM', name: 'Medium' },
        { value: 'LOW', name: 'Low' },
    ]
    const [FileNames, setFileNames] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const handleEdit = (doc) => {
        console.log('Editing document:', doc);

        openAddDocumentDialog();
        setSelectedDocId(doc.id);
        setIsEdit(true);
        setSubject(doc.description);
        setSelectedDocument(doc.type || null);
        const LastFiles = Array.isArray(doc.files)
            ? doc.files.map((fileItem, index) => ({
                id: `${doc.id}-${index}`,
                selectedId: fileItem.id,
                name: fileItem.original_filename,
                url: fileItem.file,
            }))
            : doc.files
                ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
                : [];

        setFileNames(LastFiles);
    };

    const handleDelete = async (rowKey) => {
        console.log('Deleting document with key:', rowKey);

        try {
            const id = EditId;
            const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/employee-task-documents/${rowKey}/delete/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                getDocuments()
                toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
            }
        } catch (err) {
            console.log(err);

        }
    }
    const handleUpdateDocument = async () => {
        if (!selectedDocument || !subject) {
            alert('Please fill all the fields.');
            return;
        }

        try {
            const formData = new FormData();

            // Document type
            const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
            const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
            formData.append('type', selectedDocument);
            formData.append('description', subject);

            // Append newly uploaded files
            if (uploadedFiles && uploadedFiles.length > 0) {
                uploadedFiles.forEach((file) => {
                    formData.append('uploaded_files', file);
                });
            }
            if (FileNames && FileNames.length > 0) {
                FileNames.forEach((file) => {
                    formData.append('files_to_keep', file.selectedId);
                });
            }

            const response = await axios.patch(
                `${process.env.REACT_APP_Company_Contact}/company/worktypes/${EditId}/documents/${selectedDocId}/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            if (response.status == 200 || response.status == 201) {
                getDocuments();
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setFileNames([]);
                setUploadedFiles([]);
                setIsEdit(false);
            }

            toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });

        } catch (err) {
            console.error('Failed to update document', err);
            alert('Failed to update document');
        }
    };


    return (
        <React.Fragment>
            <div className="page-content create-ajob">
                <Toast ref={toast} />
                {loader ?
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backdropFilter: "blur(1px)",  // 💥 BLUR BACKGROUND
                                        backgroundColor: "rgba(255, 255, 255, 0.4)", // soft overlay
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 9999
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "45px",
                                            height: "45px",
                                            border: "4px solid #ddd",
                                            borderTopColor: "#126fa9",
                                            borderRadius: "50%",
                                            animation: "spin 0.8s linear infinite"
                                        }}
                                    ></div>
                                </div> : ""
                            }
                <Container fluid >
                    <form onSubmit={handleSubmit}>
                        <div className="page-title-box">
                            <Row className="align-items-center">
                                <Col md={6}>
                                    <h1 className="page-title">Edit Task</h1>
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item active">
                                            Edit Task with key details for clear tracking and execution. Include a brief description, assign it to the right person, fill in system fields.
                                        </li>
                                    </ol>
                                </Col>
                                {/* <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <Toast ref={toast} />
                                    <Link to="/allactive-worktype">
                                        <button type="submit" className="btn btn-success me-2" >  <i className="pi pi-save me-1"></i> Save </button>
                                    </Link>
                                    <Link to="/allactive-worktype">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>
                            </Col> */}
                            </Row>
                        </div>

                        <Row>
                            {/* 1st Row */}
                            <Col xl={5}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Task & Assignment</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="projectName">Project Name</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Dropdown
                                                                id="project"
                                                                value={selectedProject}
                                                                onChange={(e) => { setselectedProject(e.value) }}
                                                                options={projectNameWorkTypes}
                                                                placeholder="Select Project"
                                                                className="w-full bgclr"
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="module">Select Module</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Dropdown
                                                                id="project"
                                                                value={selectedModule}
                                                                onChange={(e) => setselectedModule(e.value)}
                                                                  options={moduleWorkTypes}
                                                                // options={[
                                                                //     ...moduleWorkTypes,
                                                                //     { id: 'add', value: 'Add New', icon: 'pi pi-plus' },
                                                                //     ...(selectedModule ? [{ id: 'edit', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                // ]}
                                                                placeholder="Select Module"
                                                                className="w-full bgclr"
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                // itemTemplate={(option) => (
                                                                //     <div className="flex align-items-center gap-2">
                                                                //         {option?.icon && <i className={option.icon}></i>}
                                                                //         <span>{option.value}</span>
                                                                //     </div>
                                                                // )}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="projectManager">Project Manager</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputText
                                                                id="projectManager"
                                                                value={selectedManager}
                                                                readOnly
                                                                className="w-full"
                                                                style={{ border: '1px solid #ced4da' }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="assignedManager">Assigned To</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputText
                                                                id="assignedManager"
                                                                value={selectedAssignee}
                                                                readOnly
                                                                className="w-full"
                                                                style={{ border: '1px solid #ced4da' }}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="watcher">Add Watcher</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <MultiSelect
                                                                id="project"
                                                                value={selectedWatchers}
                                                                onChange={(e) => setSelectedWatchers(e.value)}
                                                                options={Watchers}
                                                                placeholder="Select Watchers"
                                                                className="w-full bgclr"
                                                                optionLabel="full_name"
                                                                optionValue="id"
                                                                filter
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>


                                {/* <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Timeline & Effort</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12} >

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="minSalary" className="block mb-2">
                                                                        Work Hours
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber
                                                                        inputId="minSalary"
                                                                        value={workhours}
                                                                        onValueChange={(e) => setworkhours(e.value)}
                                                                        placeholder="In Hours"
                                                                        className="w-full"
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobStartDate" className="block mb-2">Start Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobStartDate"
                                                                        value={jobStartDate}
                                                                        onChange={(e) => setJobStartDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="Select Date"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobendDate" className="block mb-2">Due Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobendDate"
                                                                        value={jobendDate}
                                                                        onChange={(e) => setJobendDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="20/05/2025"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>


                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobActualDate" className="block mb-2">Actual Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobActualDate"
                                                                        value={jobActualDate}
                                                                        onChange={(e) => setJobActualDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="20/05/2025"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card> */}


                                <Card className="bg-form">
                                    <CardBody>
                                        {/* <h4 className="card-title mb-2">Work Type Information</h4> */}
                                        <h4 className="card-title mb-2">Task Information</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">



                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="workType">Work Type</label>
                                                        </Col>
                                                        <Col xl={9}>

                                                            <Row className="">

                                                                <Col xl={6}>
                                                                    <Dropdown
                                                                        id="project"
                                                                        value={selectedWorkType}
                                                                        onChange={(e) => setselectedWorkType(e.value)}
                                                                        options={[
                                                                            ...WorkType,
                                                                            { id: 'add', value: 'Add New', name: 'Add New', icon: 'pi pi-plus' },
                                                                            ...(selectedWorkType ? [{ id: 'edit', value: 'Edit Selected', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                        ]}
                                                                        placeholder="Select Work Type"
                                                                        className="w-full bgclr"
                                                                        optionLabel="value"
                                                                        optionValue="id"
                                                                        filter
                                                                        itemTemplate={(option) => (
                                                                            <div className="flex align-items-center gap-2">
                                                                                {option.icon && <i className={option.icon}></i>}
                                                                                <span>{option.value || option.name}</span>
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </Col>
                                                                <Col xl={6}>
                                                                    <InputText
                                                                        id="projectManager"
                                                                        value="STask-101.1"
                                                                        readOnly
                                                                        className="w-full"
                                                                        style={{ border: '1px solid #ced4da' }}
                                                                    />
                                                                </Col>
                                                            </Row>


                                                        </Col>
                                                    </Row> */}
                                                    {selectedValue === "Sub Task" && <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="workType">Parent Work Type</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            {/* <WorkType1
                                                            initialWorkTypes={taskWorkTypes}
                                                            dropdownWorkTypes={taskDropdownWorkTypes}
                                                            onWorkTypesChange={handleTaskWorkTypesChange}
                                                            onSelectionChange={handleTaskSelectionChange}
                                                        /> */}
                                                            <AddProjectDetails />
                                                        </Col>
                                                    </Row>}

                                                    {/* <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="taskCode">Code</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="taskCode"
                                                            className="w-full"
                                                            placeholder="Task-101"
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row> */}

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="taskSummary">Description</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputTextarea
                                                                id="taskSummary"
                                                                value={Summary}
                                                                onChange={(e) => setSummary(e.target.value)}
                                                                className="w-full"
                                                                placeholder="Enter Description"
                                                                style={{ border: '1px solid #ced4da' }}

                                                            />
                                                        </Col>
                                                    </Row>

                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="taskStatus">Status</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <WorkType1
                                                                initialWorkTypes={statusWorkTypes}
                                                                dropdownWorkTypes={statusDropdownWorkTypes}
                                                                onWorkTypesChange={handleStatusWorkTypesChange}
                                                                onSelectionChange={handleStatusSelectionChange}
                                                            />
                                                        </Col>
                                                    </Row> */}

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            {/* <label htmlFor="workTypeStatus">Work Type Status</label> */}
                                                            <label htmlFor="workTypeStatus">Task Status</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Dropdown
                                                                id="workTypeStatus"
                                                                value={selectedWorkTypeStatus}
                                                                onChange={e => setselectedWorkTypeStatus(e.target.value)}
                                                                // onChange={e => {
                                                                //     const val = e.value;
                                                                //     if (val === 'add') {
                                                                //         setLookupModalVisible(true);
                                                                //         setLookupFormValue('');
                                                                //         setEditingLookup(false);
                                                                //         setLookupModalContext('work_type_status');
                                                                //         setselectedWorkTypeStatus(null);
                                                                //     } else if (val === 'edit') {
                                                                //         if (lastSelectedWorkTypeStatusId) {
                                                                //             setEditingLookup(true);
                                                                //             setSelectedEditdrop(lastSelectedWorkTypeStatusId);
                                                                //             const current = worktypestatus?.find(opt => opt.id === lastSelectedWorkTypeStatusId);
                                                                //             setLookupFormValue(current?.name || current?.value || '');
                                                                //             setLastSelectedLookupId(lastSelectedWorkTypeStatusId);
                                                                //             setLookupModalVisible(true);
                                                                //             setLookupModalContext('work_type_status');
                                                                //         }
                                                                //         setselectedWorkTypeStatus(lastSelectedWorkTypeStatusId);
                                                                //     } else {
                                                                //         setselectedWorkTypeStatus(val);
                                                                //         setLastSelectedWorkTypeEntityId(val);
                                                                //     }
                                                                // }}
                                                                options={worktypestatus}
                                                                // options={[
                                                                //     ...worktypestatus,
                                                                //     { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                                //     ...(selectedWorkTypeStatus ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                // ]}
                                                                placeholder="Select Work Type Status"
                                                                className="w-full bgclr"
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                // itemTemplate={(option) => (
                                                                //     <div className="flex align-items-center gap-2">
                                                                //         {option.icon && <i className={option.icon}></i>}
                                                                //         <span>{option.name || option.value}</span>
                                                                //     </div>
                                                                // )}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="taskPriority">Priority</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            {/* <Dropdown
                                                                id="priority"
                                                                value={selectedPriority}
                                                                onChange={e => {
                                                                    const val = e.value;
                                                                    if (val === 'add') {
                                                                        setLookupModalVisible(true);
                                                                        setLookupFormValue('');
                                                                        setEditingLookup(false);
                                                                        setLookupModalContext('priority');
                                                                        setSelectedPriority(null);
                                                                    } else if (val === 'edit') {
                                                                        if (lastSelectedPriorityId) {
                                                                            setEditingLookup(true);
                                                                            setSelectedEditdrop(lastSelectedPriorityId);
                                                                            const current = priorityOptions?.find(opt => opt.id === lastSelectedPriorityId);
                                                                            setLookupFormValue(current?.value || current?.name || '');
                                                                            setLastSelectedLookupId(lastSelectedPriorityId);
                                                                            setLookupModalVisible(true);
                                                                            setLookupModalContext('priority');
                                                                        }
                                                                        setSelectedPriority(lastSelectedPriorityId);
                                                                    } else {
                                                                        setSelectedPriority(val);
                                                                        setLastSelectedPriorityId(val);
                                                                    }
                                                                }}
                                                                options={[
                                                                    ...priorityOptions,
                                                                    { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                                    ...(selectedPriority ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                ]}
                                                                placeholder="Select Priority"
                                                                className="w-full bgclr"
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                itemTemplate={(option) => (
                                                                    <div className="flex align-items-center gap-2">
                                                                        {option.icon && <i className={option.icon}></i>}
                                                                        <span>{option.name || option.value}</span>
                                                                    </div>
                                                                )}
                                                            /> */}
                                                            <Dropdown
                                                                value={selectedPriority}
                                                                onChange={e => setSelectedPriority(e.target.value)}
                                                                // options={[
                                                                //   ...priorityOptions,
                                                                //   { code: "add", name: "Add New", icon: "pi pi-plus" },
                                                                //   ...(selectedPriority ? [{ code: "edit", name: "Edit Selected", icon: "pi pi-pencil" }] : []),
                                                                // ]}
                                                                options={PRIORITY_CHOICES}
                                                                optionLabel="name"
                                                                optionValue="value"
                                                                placeholder="Select Priority"
                                                                className="w-full bgclr"
                                                            // itemTemplate={(option) => (
                                                            //   <div className="flex align-items-center gap-2">
                                                            //     {option?.icon && <i className={option.icon}></i>}
                                                            //     <span>{option.name || option.value}</span>
                                                            //   </div>
                                                            // )}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="approvalStatus">Approval Status</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            {/* <WorkType1
                                                                            initialWorkTypes={approvalStatusWorkTypes}
                                                                            dropdownWorkTypes={approvalStatusDropdownWorkTypes}
                                                                            onWorkTypesChange={handleApprovalStatusWorkTypesChange}
                                                                            onSelectionChange={handleApprovalStatusSelectionChange}
                                                                        /> */}
                                                            <Dropdown
                                                                id="approvalStatus"
                                                                value={selectedStatus}
                                                                onChange={e =>setSelectedStatus(e.target.value)}
                                                                // onChange={e => {
                                                                //     const val = e.value;
                                                                //     if (val === 'add') {
                                                                //         setLookupModalVisible(true);
                                                                //         setLookupFormValue('');
                                                                //         setEditingLookup(false);
                                                                //         setLookupModalContext('approval_status');
                                                                //         setSelectedStatus(null);
                                                                //     } else if (val === 'edit') {
                                                                //         if (lastSelectedApprovalId) {
                                                                //             setEditingLookup(true);
                                                                //             setSelectedEditdrop(lastSelectedApprovalId);
                                                                //             const current = statusOptions?.find(opt => opt.id === lastSelectedApprovalId);
                                                                //             setLookupFormValue(current?.value || current?.name || '');
                                                                //             setLastSelectedLookupId(lastSelectedApprovalId);
                                                                //             setLookupModalVisible(true);
                                                                //             setLookupModalContext('approval_status');
                                                                //         }
                                                                //         setSelectedStatus(lastSelectedApprovalId);
                                                                //     } else {
                                                                //         setSelectedStatus(val);
                                                                //         setLastSelectedApprovalId(val);
                                                                //     }
                                                                // }}
                                                                options={statusOptions}
                                                                // options={[
                                                                //     ...statusOptions.map(s => ({ id: s.id, name: s.value })),
                                                                //     { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                                //     ...(selectedStatus ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                // ]}
                                                                placeholder="Select Approval Status"
                                                                className="w-full bgclr"
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                // itemTemplate={(option) => (
                                                                //     <div className="flex align-items-center gap-2">
                                                                //         {option.icon && <i className={option.icon}></i>}
                                                                //         <span>{option.name || option.value}</span>
                                                                //     </div>
                                                                // )}
                                                            />
                                                        </Col>
                                                    </Row>

                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Col xl={12}>
                                    <Card className="bg-form">
                                        <CardBody>
                                            <h4 className="card-title mb-2">System Fields</h4>
                                            <Row>
                                                <Col xl={12}>
                                                    <div className="">
                                                        <Row>
                                                            <Col xl={12}>
                                                                <Row className="mt-2 align-items-center">
                                                                    <Col xl={3}>
                                                                        <label

                                                                            className=" block"
                                                                        >
                                                                            Create Date
                                                                        </label>
                                                                    </Col>
                                                                    <Col xl={9}>
                                                                        <Calendar
                                                                            id="createDate"
                                                                            value={createDate}
                                                                            placeholder="27/02/2025"
                                                                            className="w-full"
                                                                            disabled
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mt-2 align-items-center">
                                                                    <Col xl={3}>
                                                                        <label

                                                                            className=" block"
                                                                        >
                                                                            Edit Date
                                                                        </label>
                                                                    </Col>
                                                                    <Col xl={9}>
                                                                        <Calendar
                                                                            id="editDate"
                                                                            disabled
                                                                            value={editDate}
                                                                            className="w-full"
                                                                            placeholder="27/02/2025"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mt-2 align-items-center">
                                                                    <Col xl={3}>
                                                                        <label

                                                                            className=" block"
                                                                        >
                                                                            Created By
                                                                        </label>
                                                                    </Col>
                                                                    <Col xl={9}>
                                                                        <InputText
                                                                            id="integer"
                                                                            className="w-full"
                                                                            disabled
                                                                            value={createdBy}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mt-2 align-items-center">
                                                                    <Col xl={3}>
                                                                        <label

                                                                            className=" block"
                                                                        >
                                                                            Edited By
                                                                        </label>
                                                                    </Col>
                                                                    <Col xl={9}>
                                                                        <InputText
                                                                            id="integer"
                                                                            className="w-full"
                                                                            placeholder=""
                                                                            disabled
                                                                            value={EditedBy}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                {/* Private Section */}
                                                                {/* <Row className="mt-3 align-items-center">
                                                                        <Col xl={12}>
                                                                            <div className="d-flex align-items-center">
                                                                                <Checkbox
                                                                                    inputId="checkbox"
                                                                                    checked={popchecked2}
                                                                                    onChange={handlePopupCheckbox2}
                                                                                />
                                                                                <label htmlFor="checkbox" className="ms-2">
                                                                                    Private
                                                                                </label>
                                                                            </div>
                                                                        </Col>
                                                                    </Row> */}

                                                                {popchecked2 && (
                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label htmlFor="privateUsers" className="block">
                                                                                User Id's
                                                                            </label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <MultiSelect
                                                                                value={privateDrop}
                                                                                onChange={e => setPrivateDrop(e.value)}
                                                                                options={PrivetDropdownValues}
                                                                                optionLabel={(option) => `${option.name} (${option.email})`}
                                                                                optionValue="value"
                                                                                placeholder="Select Users"
                                                                                className="w-full"
                                                                                style={{ border: '1px solid #ced4da' }}
                                                                                display="comma"
                                                                                maxSelectedLabels={3}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                )}

                                                                {/* <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label htmlFor="approvalStatus" className=" block">Approval Status</label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <Dropdown
                                                                                id="approvalStatus"
                                                                                value={selectedStatus}
                                                                                onChange={e => setSelectedStatus(e.value)}
                                                                                options={[
                                                                                    ...statusOptions.map(s => ({ id: s.id, name: s.value })),
                                                                                    { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                                                    ...(selectedStatus ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                                ]}
                                                                                placeholder="Select Approval Status"
                                                                                className="w-full bgclr"
                                                                                optionLabel="name"
                                                                                optionValue="id"
                                                                                filter
                                                                                itemTemplate={(option) => (
                                                                                    <div className="flex align-items-center gap-2">
                                                                                        {option.icon && <i className={option.icon}></i>}
                                                                                        <span>{option.name || option.value}</span>
                                                                                    </div>
                                                                                )}
                                                                            />
                                                                        </Col>
                                                                    </Row> */}

                                                                {/* <Row className="mt-2 align-items-center">
                                                            <Col xl={3}>
                                                              <label
                            
                                                                className=" block"
                                                              >
                                                                Last Activity Date
                                                              </label>
                                                            </Col>
                                                            <Col xl={9}>
                                                              <Calendar
                                                                id="lastActivityDate"
                                                                className="w-full"
                                                                placeholder="27/02/2025"
                                                                disabled
                                                              />
                                                            </Col>
                                                          </Row> */}


                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>



                                </Col>
                            </Col>

                            <Col xl={7}>
 <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Timeline & Effort</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12} >

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="minSalary" className="block mb-2">
                                                                        Work Hours
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber
                                                                        inputId="minSalary"
                                                                        value={workhours}
                                                                        onValueChange={(e) => setworkhours(e.value)}
                                                                        placeholder="In Hours"
                                                                        className="w-full"
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobStartDate" className="block mb-2">Start Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobStartDate"
                                                                        value={jobStartDate}
                                                                        onChange={(e) => setJobStartDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="Select Date"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobendDate" className="block mb-2">Due Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobendDate"
                                                                        value={jobendDate}
                                                                        onChange={(e) => setJobendDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="20/05/2025"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>


                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobActualDate" className="block mb-2">Actual Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobActualDate"
                                                                        value={jobActualDate}
                                                                        onChange={(e) => setJobActualDate(e.value)}
                                                                        dateFormat="dd/mm/yy"
                                                                        placeholder="20/05/2025"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                    />
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Documents</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div>
                                                    {/* Button to trigger the modal */}
                                                    {/* <Button
                                                      label="Add Document"
                                                      icon="pi pi-plus"
                                                      className="p-button-success"
                                                      onClick={openAddDocumentDialog}
                                                    /> */}



                                                    {/* DataTable to display added documents */}
                                                    <Row className="mt-2">
                                                        <Col xl={12}>
                                                            <div>
                                                                {/* <DataTable
                                                                    value={documents}
                                                                    rows={5}
                                                                    className="p-datatable-gridlines"
                                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                                >
                                                                    <Column
                                                                        field="type_name"
                                                                        header="Document Type"
                                                                    />
                                                                    <Column
                                                                        field="description"
                                                                        header="Subject"
                                                                    />
                                                                    <Column
                                                                        field="created_at"
                                                                        header="Uploaded On"
                                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                                    />
                                                                    <Column
                                                                        header="Attachments"
                                                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                                                            <ul className="list-unstyled mb-0">
                                                                                {rowData.files.map((fileItem) => (
                                                                                    <li key={fileItem.id}>
                                                                                        <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                                                            {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        ) : 'No file'}
                                                                    />
                                                                    <Column
                                                                        header="Actions"
                                                                        body={(rowData) => (
                                                                            <div className="d-flex gap-2">
                                                                                <Button
                                                                                    type="button"
                                                                                    icon="pi pi-pencil"
                                                                                    className="p-button-rounded p-button-text p-button-info"
                                                                                    tooltip="Edit"
                                                                                    onClick={() => handleEdit(rowData)}
                                                                                />
                                                                                <Button
                                                                                    icon="pi pi-trash"
                                                                                    className="p-button-rounded p-button-text p-button-danger"
                                                                                    tooltip="Delete"
                                                                                    type="button"
                                                                                    onClick={() => handleDelete(rowData.id)}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </DataTable> */}
                                                                <DataTable
                                                                    value={documents}
                                                                    rows={5}
                                                                    className="p-datatable-gridlines"
                                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                                >
                                                                    {/* <Column
                                                                                                    field="type_name"
                                                                                                    header="Document Type"
                                                                                                  />
                                                                                                  <Column
                                                                                                    field="description"
                                                                                                    header="Subject"
                                                                                                  /> */}
                                                                    <Column
                                                                        header="Attachments"
                                                                        body={(rowData) => rowData.file ? (
                                                                            <ul className="list-unstyled mb-0">
                                                                                <li key={rowData.id}>
                                                                                    <a href={rowData.file} target="_blank" rel="noopener noreferrer">
                                                                                        {rowData.file}
                                                                                        {/* ({(rowData.file_size / 1024).toFixed(2)} KB) */}
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        ) : 'No file'}
                                                                    />
                                                                    {/* <Column
                                                                                                    header="Attachments"
                                                                                                    body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                                                                                      <ul className="list-unstyled mb-0">
                                                                                                        {rowData.files.map((fileItem) => (
                                                                                                          <li key={fileItem.id}>
                                                                                                            <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                                                                              {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                                                                            </a>
                                                                                                          </li>
                                                                                                        ))}
                                                                                                      </ul>
                                                                                                    ) : 'No file'}
                                                                                                  /> */}
                                                                    <Column
                                                                        field="created_at"
                                                                        header="Uploaded On"
                                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                                    />
                                                                    <Column
                                                                        header="Actions"
                                                                        body={(rowData) => (
                                                                            <div className="d-flex gap-2">
                                                                                {/* <Button
                                                                                                          type="button"
                                                                                                          icon="pi pi-pencil"
                                                                                                          tooltip="Edit"
                                                                                                          onClick={() => handleEdit(rowData)}
                                                                                                        /> */}
                                                                                <Button
                                                                                    icon="pi pi-trash"
                                                                                    tooltip="Delete"
                                                                                    type="button"
                                                                                    onClick={() => handleDelete(rowData.id)}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </DataTable>
                                                                <div className="block d-flex justify-content-end align-items-center">
                                                                    <a className="anchr-title mt-3" onClick={openAddDocumentDialog}>
                                                                        <i className="pi pi-plus me-1"></i> Add More
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                    </Row>

                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>

                                    {/* Dialog for adding document */}
                                    <Dialog
                                        header="Add Document"
                                        visible={displayDialog}
                                        onHide={closeAddDocumentDialog}
                                        style={{ width: "30vw" }}
                                        footer={
                                            <div className="d-flex justify-content-end gap-2">
                                                {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument} disabled={docloader}>
                                                    <i className="pi pi-pencil me-1"></i>
                                                    Update
                                                </Button> :
                                                    <Button color="primary btn-main mr-2" onClick={handleAddDocument} disabled={docloader}>
                                                        {/* <i className="pi pi-plus me-1"></i> */}
                                                        Add Document
                                                    </Button>}
                                                <Button color="btn btn-primary cancel-outlinebtn" onClick={closeAddDocumentDialog} disabled={docloader}>
                                                    {/* <i className="pi pi-times me-1"></i> */}
                                                    Cancel
                                                </Button>
                                            </div>
                                        }
                                    >
                                        {/* <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="documentType" className="block mb-2">
                                                    Document Type
                                                </label>
                                            </Col>
                                            <Col xl={9}>
                                                <Dropdown
                                                    id="documentType"
                                                    value={selectedDocument}
                                                    onChange={(e) => setSelectedDocument(e.value)}
                                                    options={[
                                                        ...documentTypes,
                                                        { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                        ...(selectedDocument ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                    ]}
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    className="w-full bgclr"
                                                    style={{ border: '1px solid #ced4da' }}
                                                    placeholder="Select Document Type"
                                                    itemTemplate={(option) => (
                                                        <div className="flex align-items-center gap-2">
                                                            {option?.icon && <i className={option.icon}></i>}
                                                            <span>{option.name || option.value}</span>
                                                        </div>
                                                    )}
                                                />
                                            </Col>
                                        </Row> */}

                                        {/* <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="documentSubject" className="block mb-2">
                                                    Document Subject
                                                </label>
                                            </Col>
                                            <Col xl={9}>
                                                <InputText
                                                    id="documentSubject"
                                                    value={subject}
                                                    onChange={(e) => setSubject(e.target.value)}
                                                    className="w-full"
                                                    style={{ border: '1px solid #ced4da' }}
                                                    placeholder="Enter document subject or description"
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mt-2 align-items-center">
                                                <label htmlFor="documentAttachment" className="block mb-2">
                                                    File Attachment
                                                </label>
                                            <Col xl={12}>
                                                <FileUpload
                                                    ref={fileUploadRef}
                                                    name="files[]"
                                                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    maxFileSize={5242880}
                                                    multiple
                                                    customUpload
                                                    disabled={docloader}
                                                    auto={false}
                                                    onSelect={(e) => {
                                                        const currentFiles = uploadedFiles || [];
                                                        const newFiles = e.files || [];

                                                        // Calculate total size including existing files
                                                        const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                        const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                        const totalSize = currentTotalSize + newTotalSize;

                                                        // Check total size limit (5MB = 5,242,880 bytes)
                                                        if (totalSize > 5242880) {
                                                            toast.current?.show({
                                                                severity: 'error',
                                                                summary: 'File Size Error',
                                                                detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB`
                                                            });

                                                            // Clear the new selection but preserve existing files
                                                            if (fileUploadRef.current) {
                                                                fileUploadRef.current.clear();
                                                                if (currentFiles.length > 0) {
                                                                    fileUploadRef.current.setFiles(currentFiles);
                                                                }
                                                            }
                                                            return;
                                                        }

                                                        // Check file types
                                                        const allowedTypes = [
                                                            'image/jpeg', 'image/jpg', 'image/png',
                                                            'application/pdf',
                                                            'application/msword',
                                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                            'text/plain',
                                                            'application/vnd.ms-excel',
                                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                        ];

                                                        const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                                                        if (invalidFiles.length > 0) {
                                                            toast.current?.show({
                                                                severity: 'error',
                                                                summary: 'Invalid File Type',
                                                                detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`
                                                            });

                                                            // Clear the new selection but preserve existing files
                                                            if (fileUploadRef.current) {
                                                                fileUploadRef.current.clear();
                                                                if (currentFiles.length > 0) {
                                                                    fileUploadRef.current.setFiles(currentFiles);
                                                                }
                                                            }
                                                            return;
                                                        }

                                                        // All validations passed, update the files
                                                        const combinedFiles = [...currentFiles, ...newFiles];
                                                        setUploadedFiles(combinedFiles);
                                                    }}
                                                    uploadHandler={(e) => {
                                                        console.log("Upload handler called", e.files);
                                                    }}
                                                    onClear={() => {
                                                        console.log("Files cleared");
                                                        setUploadedFiles([]);
                                                    }}
                                                />
                                                <small className="text-muted">
                                                    Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                                                </small>
                                            </Col>
                                        </Row>
                                        {FileNames && FileNames.length > 0 && (
                                            <Row className="mt-2 align-items-center">
                                                <Col xl={3}>
                                                    <label className="block mb-2">Previously Attached Files</label>
                                                </Col>
                                                <Col xl={9}>
                                                    {FileNames.map((file) => (
                                                        <div key={file.id} className="d-flex align-items-center mb-2">
                                                            <a
                                                                href={file.url || file.name} // use URL if available
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="me-2"
                                                            >
                                                                {file.name.split('/').pop()}
                                                            </a>
                                                            <i
                                                                className="pi pi-times"
                                                                style={{ cursor: "pointer", color: "red" }}
                                                                onClick={() => {
                                                                    // Remove the clicked file from FileNames
                                                                    setFileNames(prev => prev.filter(f => f.id !== file.id));
                                                                }}
                                                            ></i>
                                                        </div>
                                                    ))}
                                                </Col>

                                            </Row>
                                        )}
                                    </Dialog>
                                    {/* <Dialog
                                        header={
                                            lookupModalContext === 'priority' ? (editingLookup ? 'Edit Priority' : 'Add Priority') :
                                            lookupModalContext === 'work_type' ? (editingLookup ? 'Edit Work Type' : 'Add Work Type') :
                                            lookupModalContext === 'approval' ? (editingLookup ? 'Edit Approval Status' : 'Add Approval Status') :
                                            lookupModalContext === 'work_type_document' ? (editingLookup ? 'Edit Document Type' : 'Add Document Type') :
                                            lookupModalContext === 'work_type_status' ? (editingLookup ? 'Edit Work Type Status' : 'Add Work Type Status') :
                                            (editingLookup ? 'Edit' : 'Add')
                                        }
                                        visible={lookupModalVisible}
                                        onHide={() => setLookupModalVisible(false)}
                                        style={{ width: "30vw" }}
                                        footer={
                                            <div>
                                                <Button color="primary btn-main mr-2" onClick={() => handleLookupSave()}>
                                                    <i className="pi pi-save me-1"></i>
                                                    {editingLookup ? 'Update' : 'Add'}
                                                </Button>
                                                <Button color="btn btn-primary cancel-outlinebtn" onClick={() => setLookupModalVisible(false)}>
                                                    <i className="pi pi-times me-1"></i>
                                                    Cancel
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="lookupName" className="block mb-2">
                                                    {lookupModalContext === 'priority' ? 'Priority' : lookupModalContext === 'work_type' ? 'Work Type' : lookupModalContext === 'approval' ? 'Approval Status' : lookupModalContext === 'work_type_document' ? 'Document Type' : lookupModalContext === 'work_type_status' ? 'Work Type Status' : 'Value'}
                                                </label>
                                            </Col>
                                            <Col xl={9}>
                                                <InputText id="lookupName" value={lookupFormValue} onChange={(e) => setLookupFormValue(e.target.value)} className="w-full" />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="lookupDescription" className="block mb-2">Description</label>
                                            </Col>
                                            <Col xl={9}>
                                                <Input type="textarea" id="lookupDescription" value={description} onChange={(e) => setdescription(e.target.value)} className="w-full" />
                                            </Col>
                                        </Row>
                                    </Dialog> */}
                                </Card>

                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Comments</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <DataTable
                                                        value={comments}
                                                        rows={5}
                                                        className="p-datatable-gridlines"
                                                        emptyMessage={<div className="empty-message-custom">No comments found.</div>}
                                                    >
                                                        <Column
                                                            field="comment_text"
                                                            header="Comment"
                                                        />
                                                        <Column
                                                            field="created_at"
                                                            header="Commented On"
                                                            body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                        />
                                                        <Column
                                                            field="created_by_name"
                                                            header="Commented By"
                                                        />
                                                        <Column
                                                            header="Attachments"
                                                            body={(rowData) =>
                                                                rowData.attachments && rowData.attachments.length > 0 ? (
                                                                    <ul className="list-unstyled mb-0">
                                                                        {rowData.attachments.map((att) => (
                                                                            <li key={att.id}>
                                                                                <a
                                                                                    href={att.attachment_file}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {att.attachment_file.split("/").pop()}
                                                                                </a>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                ) : (
                                                                    "No file"
                                                                )
                                                            }
                                                        />

                                                    </DataTable>
                                                </div>
                                                <div className="block d-flex justify-content-end align-items-center">
                                                    <a className="anchr-title mt-3" onClick={() => setCommentDialogVisible(true)}>
                                                        <i className="pi pi-plus me-1"></i> Add More
                                                    </a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
 <Dialog
                                        header="Add Document"
                                        visible={commentDialogVisible}
                                        onHide={closeAddDocumentDialog}
                                        disabled={commentloader}
                                        style={{ width: "30vw" }}
                                        footer={
                                            <div className="d-flex justify-content-end gap-2">
                                                {/* {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                                                    <i className="pi pi-pencil me-1"></i>
                                                    Update
                                                </Button> : */}
                                                    <Button color="primary btn-main mr-2" onClick={handleAddComment} disabled={commentloader}>
                                                        Add Comment
                                                    </Button>
                                                <Button color="btn btn-primary cancel-outlinebtn" onClick={closeAddDocumentDialog} disabled={commentloader}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        }
                                    >

                                        <Row className="mt-2 align-items-center">
                                                <label htmlFor="comment" className="block mb-2">
                                                    Comment <span className="text-danger">*</span>
                                                </label>
                                            <Col xl={12}>
                                                <InputTextarea
                                                    id="comment"
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                    disabled={commentloader}
                                                    className="w-full"
                                                    style={{ border: '1px solid #ced4da' }}
                                                    placeholder="Enter comment "
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mt-2 align-items-center">
                                                <label htmlFor="documentAttachment" className="block mb-2">
                                                    File Attachment
                                                </label>
                                            <Col xl={12}>
                                                <FileUpload
                                                    ref={fileUploadRef}
                                                    name="files[]"
                                                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    maxFileSize={5242880}
                                                    multiple
                                                    customUpload
                                                    auto={false}
                                                    disabled={commentloader}
                                                    onSelect={(e) => {
                                                        const currentFiles = uploadedFiles || [];
                                                        const newFiles = e.files || [];

                                                        // Calculate total size including existing files
                                                        const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                        const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                        const totalSize = currentTotalSize + newTotalSize;

                                                        // Check total size limit (5MB = 5,242,880 bytes)
                                                        if (totalSize > 5242880) {
                                                            toast.current?.show({
                                                                severity: 'error',
                                                                summary: 'File Size Error',
                                                                detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB`
                                                            });

                                                            // Clear the new selection but preserve existing files
                                                            if (fileUploadRef.current) {
                                                                fileUploadRef.current.clear();
                                                                if (currentFiles.length > 0) {
                                                                    fileUploadRef.current.setFiles(currentFiles);
                                                                }
                                                            }
                                                            return;
                                                        }

                                                        // Check file types
                                                        const allowedTypes = [
                                                            'image/jpeg', 'image/jpg', 'image/png',
                                                            'application/pdf',
                                                            'application/msword',
                                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                            'text/plain',
                                                            'application/vnd.ms-excel',
                                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                        ];

                                                        const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                                                        if (invalidFiles.length > 0) {
                                                            toast.current?.show({
                                                                severity: 'error',
                                                                summary: 'Invalid File Type',
                                                                detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`
                                                            });

                                                            // Clear the new selection but preserve existing files
                                                            if (fileUploadRef.current) {
                                                                fileUploadRef.current.clear();
                                                                if (currentFiles.length > 0) {
                                                                    fileUploadRef.current.setFiles(currentFiles);
                                                                }
                                                            }
                                                            return;
                                                        }

                                                        // All validations passed, update the files
                                                        const combinedFiles = [...currentFiles, ...newFiles];
                                                        setCommentFiles(combinedFiles);
                                                    }}
                                                    uploadHandler={(e) => {
                                                        console.log("Upload handler called", e.files);
                                                    }}
                                                    onClear={() => {
                                                        console.log("Files cleared");
                                                        setCommentFiles([]);
                                                    }}
                                                />
                                                <small className="text-muted">
                                                    Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                                                </small>
                                            </Col>
                                        </Row>
                                        {/* {commentFiles && commentFiles.length > 0 && (
                                            <Row className="mt-2 align-items-center">
                                                <Col xl={9}>
                                                    {commentFiles.map((file) => (
                                                        <div key={file.id} className="d-flex align-items-center mb-2">
                                                            <a
                                                                href={file.url || file.name} // use URL if available
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="me-2"
                                                            >
                                                                {file.name.split('/').pop()}
                                                            </a>
                                                            <i
                                                                className="pi pi-times"
                                                                style={{ cursor: "pointer", color: "red" }}
                                                                onClick={() => {
                                                                    // Remove the clicked file from FileNames
                                                                    setCommentFiles(prev => prev.filter(f => f.id !== file.id));
                                                                }}
                                                            ></i>
                                                        </div>
                                                    ))}
                                                </Col>

                                            </Row>
                                        )} */}
                                    </Dialog>
                                <Row>
                                    <Col xl={6}>


                                        {/* <Card className="bg-form">
                                            <CardBody>
                                                <h4 className="card-title mb-2">Approval Status</h4>
                                                <Row>
                                                    <Col xl={12}>
                                                        <div className="">
                                                            <Row>
                                                                <Col xl={12}>


                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label htmlFor="approvalStatus">Approval Status</label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            
                                                                            <Dropdown
                                                                                id="approvalStatus"
                                                                                value={selectedStatus}
                                                                                onChange={e => {
                                                                                    const val = e.value;
                                                                                    if (val === 'add') {
                                                                                        setLookupModalVisible(true);
                                                                                        setLookupFormValue('');
                                                                                        setEditingLookup(false);
                                                                                        setLookupModalContext('approval_status');
                                                                                        setSelectedStatus(null);
                                                                                    } else if (val === 'edit') {
                                                                                        if (lastSelectedApprovalId) {
                                                                                            setEditingLookup(true);
                                                                                            setSelectedEditdrop(lastSelectedApprovalId);
                                                                                            const current = statusOptions?.find(opt => opt.id === lastSelectedApprovalId);
                                                                                            setLookupFormValue(current?.value || current?.name || '');
                                                                                            setLastSelectedLookupId(lastSelectedApprovalId);
                                                                                            setLookupModalVisible(true);
                                                                                            setLookupModalContext('approval_status');
                                                                                        }
                                                                                        setSelectedStatus(lastSelectedApprovalId);
                                                                                    } else {
                                                                                        setSelectedStatus(val);
                                                                                        setLastSelectedApprovalId(val);
                                                                                    }
                                                                                }}
                                                                                options={[
                                                                                    ...statusOptions.map(s => ({ id: s.id, name: s.value })),
                                                                                    { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
                                                                                    ...(selectedStatus ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                                                ]}
                                                                                placeholder="Select Approval Status"
                                                                                className="w-full bgclr"
                                                                                optionLabel="name"
                                                                                optionValue="id"
                                                                                filter
                                                                                itemTemplate={(option) => (
                                                                                    <div className="flex align-items-center gap-2">
                                                                                        {option.icon && <i className={option.icon}></i>}
                                                                                        <span>{option.name || option.value}</span>
                                                                                    </div>
                                                                                )}
                                                                            />
                                                                        </Col>
                                                                    </Row>




                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card> */}





                                    </Col>
                                    {/* <Col xl={6}>
                                        <Card className="bg-form">
                                            <CardBody>
                                                <h4 className="card-title mb-2">System Fields</h4>
                                                <Row>
                                                    <Col xl={12}>
                                                        <div className="">
                                                            <Row>
                                                                <Col xl={12}>
                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label

                                                                                className=" block"
                                                                            >
                                                                                Create Date
                                                                            </label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <Calendar
                                                                                id="createDate"
                                                                                value={createDate}
                                                                                placeholder="27/02/2025"
                                                                                className="w-full"
                                                                                disabled
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label

                                                                                className=" block"
                                                                            >
                                                                                Edit Date
                                                                            </label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <Calendar
                                                                                id="editDate"
                                                                                disabled
                                                                                value={editDate}
                                                                                className="w-full"
                                                                                placeholder="27/02/2025"
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label

                                                                                className=" block"
                                                                            >
                                                                                Created By
                                                                            </label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <InputText
                                                                                id="integer"
                                                                                className="w-full"
                                                                                disabled
                                                                                value={createdBy}
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label

                                                                                className=" block"
                                                                            >
                                                                                Edited By
                                                                            </label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <InputText
                                                                                id="integer"
                                                                                className="w-full"
                                                                                placeholder=""
                                                                                disabled
                                                                                value={EditedBy}
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    
                                                                    <Row className="mt-3 align-items-center">
                                                                        <Col xl={12}>
                                                                            <div className="d-flex align-items-center">
                                                                                <Checkbox
                                                                                    inputId="checkbox"
                                                                                    checked={popchecked2}
                                                                                    onChange={handlePopupCheckbox2}
                                                                                />
                                                                                <label htmlFor="checkbox" className="ms-2">
                                                                                    Private
                                                                                </label>
                                                                            </div>
                                                                        </Col>
                                                                    </Row> 

                                                                    {popchecked2 && (
                                                                        <Row className="mt-2 align-items-center">
                                                                            <Col xl={3}>
                                                                                <label htmlFor="privateUsers" className="block">
                                                                                    User Id's
                                                                                </label>
                                                                            </Col>
                                                                            <Col xl={9}>
                                                                                <MultiSelect
                                                                                    value={privateDrop}
                                                                                    onChange={e => setPrivateDrop(e.value)}
                                                                                    options={PrivetDropdownValues}
                                                                                    optionLabel={(option) => `${option.name} (${option.email})`}
                                                                                    optionValue="value"
                                                                                    placeholder="Select Users"
                                                                                    className="w-full"
                                                                                    style={{ border: '1px solid #ced4da' }}
                                                                                    display="comma"
                                                                                    maxSelectedLabels={3}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    )}


                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>



                                    </Col> */}
                                </Row>



                            </Col>


                            {/* 2nd Row */}

                            {/* <Col xl={4}>
                            

                           

                               

                       
                            

                        </Col> */}








                            {/* 3rd Row */}

                            {/* <Col xl={4}>

                           


                        </Col> */}
                        </Row >

                        <Row className="align-items-center mb-3">

                            <Col md={12}>
                                <div className="d-flex justify-content-end">
                                    {/* <Link to="/allactive-worktype"> */}
                                    <button type="submit" class="btn btn-success me-2">  <i className="pi pi-save me-1"></i>Save</button>
                                    {/* </Link> */}

                                    <Link to="/allactive-worktype">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                            onClick={showCancel}
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>

                            </Col>
                        </Row>
                    </form>
                    <Dialog
                        header={
                            editingLookup
                                ? lookupModalContext === "project_groups"
                                    ? "Edit Group"
                                    : lookupModalContext === "project_status"
                                        ? "Edit Status"
                                        : "Edit"
                                : lookupModalContext === "project_groups"
                                    ? "Add Group"
                                    : lookupModalContext === "project_status"
                                        ? "Add Status"
                                        : "Add"
                        }

                        visible={lookupModalVisible}
                        style={{ width: "30vw" }}
                        onHide={() => { setLookupModalVisible(false); setdescription(''); setLastSelectedLookupId(null); }}
                    >
                        <div className="p-fluid">
                            {/* Dropdown - only visible when editing */}
                            {editingLookup && (
                                <>
                                    <label className="mb-1">Select to edit</label>
                                    <Dropdown
                                        id="worktype"
                                        value={SelectedEditdrop}
                                        onChange={(e) => {
                                            setSelectedEditdrop(e.value);

                                            const selectedOption = selecteddropoptions.find(opt => opt.id === e.value);
                                            if (selectedOption) {
                                                setLookupFormValue(selectedOption.name);
                                            }
                                        }}
                                        options={selecteddropoptions}
                                        placeholder="Select Work Type"
                                        className="w-full bgclr mb-2"
                                        optionLabel='name'
                                        optionValue="id"
                                        filter
                                    />
                                </>
                            )}

                            {/* Work type name */}
                            <label className="mb-1">
                                {lookupModalContext === "project_groups" ? "Group Name" : "Status Name"} <span className="text-danger">*</span>
                            </label>
                            <InputText
                                value={lookupFormValue}
                                onChange={(e) => setLookupFormValue(e.target.value)}
                                className="w-full mb-3"
                            />

                            {/* Description */}
                            <label className="mb-1">Description</label>
                            <InputTextarea
                                value={description}
                                onChange={(e) => setdescription(e.target.value)}
                                rows={3}
                                className="w-full"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="gap-2 d-flex justify-content-end mt-3">
                            <Button
                                label="Cancel"
                                className="p-button-text"
                                onClick={() => setLookupModalVisible(false)}
                            />
                            <Button label="Save" className="p-ml-2" onClick={handleLookupSave} />
                        </div>
                    </Dialog>
                </Container >
            </div >
        </React.Fragment >
    )
}

export default WorkTypeEditForm;
